/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type SocialAnamnesisDtoHousingStatus =
  (typeof SocialAnamnesisDtoHousingStatus)[keyof typeof SocialAnamnesisDtoHousingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocialAnamnesisDtoHousingStatus = {
  UNKNOWN: 'UNKNOWN',
  ASYLUM: 'ASYLUM',
  PRIVATE: 'PRIVATE',
  SHARED: 'SHARED',
  ASSISTED_LIVING: 'ASSISTED_LIVING',
  HOMELESS: 'HOMELESS',
  PRISON: 'PRISON',
  HIDING: 'HIDING',
  MEDICAL_FACILITY: 'MEDICAL_FACILITY',
} as const;
